import React, { useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from "@mui/icons-material/Search";
import {
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select, styled, Switch, TextField, Tooltip
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { DateRangeControl,useGlobalStore } from '../../../common';
import { getEndDate, getStartDate } from '../../../util/date';
import PrimaryFiltersDisregardDialog from './PrimaryFiltersDisregardDialog/PrimaryFiltersDisregardDialog';
import { DeleteConfirmation as ExcludingContractsConfirmation} from '../../../common/GenericDeleteConfirmationDialog/DeleteConfirmationDialog';

const useStyles = makeStyles(theme => ({
    switch: {
        marginRight: 0,
        marginTop: 15,
        marginLeft: 0,
        '@media (max-width: 1440px)': {
            width: '95px',
        },
        '& .MuiTypography-root':{
            fontSize:"11px"
        },
            flexDirection:"column-reverse"
    },
    gridMDMargin: {
        '@media (max-width: 1023px)': {
            paddingLeft: 10,
        }
    },
    formControlClaim: {
        margin: theme.spacing(1),
        width: 55
    },
    formControlPaid: {
        margin: theme.spacing(1),
        width: 70
    },
    formControlStatus: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: 4,
        marginRight: 4,
        width: 140,
        '@media (max-width: 1645px)': {
            width: 79,
        },
        '@media (max-width: 1366px)': {
            width: 60,
        }
    },
    width:{width:'62px'},
    formControlVarianceStatus: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: 4,
        marginRight: 4,
        width: 110,
        '@media (max-width: 1645px)': {
            width: 79,
        },
        '@media (max-width: 1366px)': {
            width: 60,
        }
    },
    formControlState: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: 4,
        marginRight: 4,
        width: 90,
        '@media (max-width: 1645px)': {
            width: 79,
        },
    },
    accordionFormControl: {
        margin: theme.spacing(2),
        width: '80%'
    },
    filterBorderBottom: {
        border: '1px solid #EBEDF2'
    },
    claimFilterAccordion: {
        position: 'absolute',
        width: '460px',
        minHeight: '210px',
        right: '-1px',
        '@media (max-width: 768px)': {
            width: '100%',
        },
        top: '67px',
        backgroundColor: '#fff',
        zIndex: 111,
        boxShadow: '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
    },
    filterIcon: {
        '@media (min-width: 1366px)': {
            display: 'none'
        },
    },
    defaultVisibleFilters: {
        '@media (max-width: 1365px)': {
            display: 'none'
        },
    },
    advFilterBtn: {
        display: 'grid',
        alignItems: 'flex-end',
        paddingBottom: "11px !important",
        '& .MuiButtonBase-root': {
            textTransform: 'capitalize !important'
        }
    },
    ackStatus:{
        width:'100px',
        '@media (max-width: 1500px)': {
            width: '80px',
        },
    },
    claimSearchField:{
            '& .MuiFormHelperText-root': {
            fontSize:"9px"
            }
    }
}));
const unpaidExcludedFilters = ['remitDate','remitdate', 'chargedAmount', 'actualPay', 'variance', 'reasoncode','isDenial','recoveredAmount','isDenial'];

const filterFields = [{
    label: 'Remit Date',
    value: 'remitdate'
}, {
    label: 'Service Date',
    value: 'servicedate',
}];

interface ClaimAnalysisTopFiltersProps {
    intl : any;
    pending?: boolean;
    pendingState?: boolean;
    customFilter: Array<{ field: string; value: string }>;
    handleRefresh: () => void;
    relativeFilter: string;
    relativeFilterValue: string;
    significanceFlag: boolean;
    tableFiltersPtr: any;
    ignoreDueToQuickSearch:boolean;
    pageState:any;
    actions: {
        setMulti: (params: { list?: any[]; significance?: boolean; customFilter?: any[]; isCustomFilterSetEmpty?: boolean,filter?:any[];searchTerm?:any ;showIgnoredFilterDialog?:boolean;ignoreAcknowledgement?:boolean}) => void;
        setRelativeFilter: (value: string) => void;
    };
}

function ClaimAnalysisTopFilters({
    pending : a_pending,
    pendingState,
    tableFiltersPtr,
    handleRefresh,
    relativeFilter,
    relativeFilterValue,
    actions: { setRelativeFilter }
}: ClaimAnalysisTopFiltersProps) {
    function setMulti(params) {
        tableFiltersPtr.update( prev => ({
            ...prev,
            ...params
        }));
    }

    const tinyContracts = useGlobalStore( x => x.contracts.tiny );
    
    const isAssignedFilterApplied = () => {
        const appliedAssignedFilters = tableFiltersPtr?.value?.filter?.filter(
            (item) => item?.field === "assignedTo"
        );

        return appliedAssignedFilters?.length > 0;
    };
    const isContractNameFilterApplied = (defaultState = undefined) => {
        const appliedContractNameFilters =
            tableFiltersPtr?.value?.filter?.filter((item) => {
                if (item?.field !== "contract.name") return;
                let existingContractsWithSameState = defaultState
                    ? tinyContracts?.find(
                          (rec) =>
                              rec?.name === item?.value &&
                              rec?.state?.toLowerCase() !== defaultState
                      )
                    : tinyContracts?.find(
                          (rec) =>
                              rec?.name === item?.value &&
                              rec?.state?.toLowerCase() === contractState
                      );
                if (existingContractsWithSameState) {
                    return true;
                }
                return false;
            });
        return appliedContractNameFilters?.length > 0;
    };

    const pending = a_pending || pendingState;

    const { customFilter, significance: significanceFlag, ignoreAcknowledgement: ignoreDueToQuickSearch, searchTerm,assigned } = tableFiltersPtr.value;

    const [significance, setSignificance] = useState(true);
    const [assignedToMe, setAssignedToMe] = useState(true);
    const [isSignificanceDisabled, setSignificanceDisabled] = useState(false);
    const [isFirst, setIsFirst] = useState(true);

    const [acknowledgeFilter, setAcknowledgeFilter] = useState('both');
    const [followUpFilter, setFollowUpFilter] = useState('both');
    const [isPaidFilter, setPaidFilter] = useState<string | boolean>('both');
    const [denialFilter, setDenialFilter] = useState('both');
    const [contractState, setContractState] = useState('both');
    const [isAccordionOpen, setAccordionOpen] = useState(false);
    const [disregardDialog, setDisregardDialog] = useState(false);
    const [claimNumber, setClaimNumber] = useState("");
    const [contractsStateChangeConfirm, setContractsStateChangeConfirm] = useState<any>({open:false});


    let selectedDate= customFilter.filter((cf) => {
        return filterFields.find((f) => {
            return cf.field === f.value;
        });
    }) as any

    
    const startEF = selectedDate.find(item => item.equator === 'greater_than_or_equals_to');
    const endEF = selectedDate.find(item => item.equator === 'less_than_or_equals_to');


    const classes = useStyles();

    // Track previous values to detect actual changes - initialize ONCE with initial values
    const hasInitializedRefs = React.useRef(false);
    const prevSignificance = React.useRef(significance);
    const prevAssignedToMe = React.useRef(assignedToMe);
    
    // Initialize refs only once on mount
    if (!hasInitializedRefs.current) {
        prevSignificance.current = significance;
        prevAssignedToMe.current = assignedToMe;
        hasInitializedRefs.current = true;
    }

    useEffect(() => {
        setSignificance(significanceFlag);
    }, [significanceFlag])

    useEffect(() => {
        setAssignedToMe(assigned);
    }, [assigned])

    useEffect(() => {
        const nextAcknowledgeFilter = customFilter.find(x => x.field === 'acknowledged')?.value ?? 'both';
        acknowledgeFilter !== nextAcknowledgeFilter && setAcknowledgeFilter(nextAcknowledgeFilter);

        const nextIsPaidFilter = customFilter.find(x => x.field === 'isPaid')?.value ?? 'both';
        isPaidFilter !== nextIsPaidFilter && setPaidFilter(nextIsPaidFilter);

        const nextFollowUpFilter = customFilter.find(x => x.field === 'flag')?.value ?? 'both';
        followUpFilter !== nextFollowUpFilter && setFollowUpFilter(nextFollowUpFilter);

        const nextDenialFilter = customFilter.find(x => x.field === 'isDenial')?.value ?? 'both';
        denialFilter !== nextDenialFilter && setDenialFilter(nextDenialFilter);

        const nextContractState = customFilter.find(x => x.field === 'contract.contractState.name')?.value ?? 'both';
        contractState !== nextContractState && setContractState(nextContractState?.toLowerCase());

        setClaimNumber(searchTerm);
        
    }, [customFilter]);


    // Track when filters were last updated from advanced dialog
    const lastAdvancedFilterUpdate = React.useRef(0);
    
    // Update timestamp when advanced filters change
    useEffect(() => {
        const basicFilterFields = ['acknowledged', 'flag', 'isDenial', 'isPaid', 'contract.contractState.name', 'remitdate', 'servicedate'];
        const hasAdvancedFilters = customFilter.some(f => !basicFilterFields.includes(f.field));
        if (hasAdvancedFilters) {
            lastAdvancedFilterUpdate.current = Date.now();
        }
    }, [customFilter]);

    useEffect(() => {
        // Only trigger if significance or assignedToMe actually changed (not on mount or customFilter changes)
        const significanceChanged = prevSignificance.current !== significance;
        const assignedChanged = prevAssignedToMe.current !== assignedToMe;
        
        // Check if advanced filters were recently applied (within last 1 second)
        const recentlyAppliedAdvancedFilters = (Date.now() - lastAdvancedFilterUpdate.current) < 1000;
        
        if (!isFirst && (significanceChanged || assignedChanged)) {
            // Check if we have advanced filters applied (filters not in the basic top filter fields)
            const basicFilterFields = ['acknowledged', 'flag', 'isDenial', 'isPaid', 'contract.contractState.name', 'remitdate', 'servicedate'];
            const hasAdvancedFilters = customFilter.some(f => !basicFilterFields.includes(f.field));
            
            // Don't clear filters if we have advanced filters applied and only significance changed
            // OR if advanced filters were recently applied (to prevent race conditions)
            if ((hasAdvancedFilters && significanceChanged && !assignedChanged) || recentlyAppliedAdvancedFilters) {
                // Just update significance, keep filters
                setMulti({
                    list: [],
                    significance
                });
                setSignificanceDisabled(false);
            } else {
                // Original behavior for assignedToMe changes or when no advanced filters
                setTimeout(() => {
                    setMulti({
                        list: [],
                        ...(isSignificanceDisabled  ? {significance}:{}), 
                        assigned:assignedToMe,
                        ...(assignedToMe ? {filter:[],customFilter:[],significance:isSignificanceDisabled ? significance:false}:{})
                    });
                    setSignificanceDisabled(false);
                }, 200);
            }
        }
        
        // Update refs for next comparison
        prevSignificance.current = significance;
        prevAssignedToMe.current = assignedToMe;
        setIsFirst(false);

    }, [significance, assignedToMe])

    const handleSignificanceChange = (event) => {
        setSignificanceDisabled(true);
        setSignificance(event.target.checked);
    }

    const handleAssignedToMeChange = (event) => {
        setAssignedToMe(event.target.checked);
    }

    const handleClaimNumberSearchChange = (event) => {
        setClaimNumber(event.target.value);

        if (event.target.value?.length === 0) {
            setMulti({
                searchTerm: event.target.value,
                showIgnoredFilterDialog: false,
                ignoreAcknowledgement: false,
            });
        }
    };

    const handleAcknowledgedFilterChange = (event) => {

        const filterValue = event.target.value;
        setAcknowledgeFilter(filterValue);

        if (filterValue !== 'both') {
            const cf = {
                field: 'acknowledged',
                equator: 'equals',
                value: filterValue,
            }
            if (customFilter && customFilter.length > 0) {
                const existingFilter = customFilter.filter(x => x.field !== 'acknowledged');
                setMulti({
                    list: [],
                    customFilter: [...existingFilter, cf]
                });
            } else {
                setMulti({
                    list: [],
                    customFilter: [cf]
                });
            }

        } else {
            if (customFilter && customFilter.length > 0) {
                const existingFilter = customFilter.filter(x => x.field !== 'acknowledged');
                if (existingFilter.length === 0) {
                    setMulti({
                        isCustomFilterSetEmpty: true,
                        list: [],
                        customFilter: existingFilter
                    });
                } else {
                    setMulti({
                        list: [],
                        customFilter: existingFilter
                    });
                }
            }
        }
    };

    const handleFollowupFilterChange = (event) => {

        const filterValue = event.target.value;
        setFollowUpFilter(filterValue);

        if (filterValue !== 'both') {
            const cf = {
                field: 'flag',
                equator: 'equals',
                value: filterValue,
            }
            if (customFilter && customFilter.length > 0) {
                const existingFilter = customFilter.filter(x => x.field !== 'flag');
                setMulti({
                    list: [],
                    customFilter: [
                        ...existingFilter,
                        cf,
                    ]
                });
            } else {
                setMulti({
                    list: [],
                    customFilter: [cf]
                });
            }

        } else {
            if (customFilter && customFilter.length > 0) {
                const existingFilter = customFilter.filter(x => x.field !== 'flag');
                if (existingFilter.length === 0) {
                    setMulti({
                        isCustomFilterSetEmpty: true,
                        list: [],
                        customFilter: existingFilter
                    });
                } else {
                    setMulti({
                        list: [],
                        customFilter: existingFilter
                    });
                }
            }
        }
    };

    const handleDenialFilterChange = (event) => {
        const filterValue = event.target.value;
        setDenialFilter(filterValue);

        if (filterValue !== 'both') {
            const cf = {
                field: 'isDenial',
                equator: 'equals',
                value: filterValue,
            }
            if (customFilter && customFilter.length > 0) {
                const existingFilter = customFilter.filter(x => x.field !== 'isDenial');
                setMulti({
                    list: [],
                    customFilter: [
                        ...existingFilter,
                        cf,
                    ]
                });
            } else {
                setMulti({
                    list: [],
                    customFilter: [cf]
                });
            }

        } else {
            if (customFilter && customFilter.length > 0) {
                const existingFilter = customFilter.filter(x => x.field !== 'isDenial');
                if (existingFilter.length === 0) {
                    setMulti({
                        isCustomFilterSetEmpty: true,
                        list: [],
                        customFilter: existingFilter
                    });
                } else {
                    setMulti({
                        list: [],
                        customFilter: existingFilter
                    });
                }
            }
        }
    };

    const handlePaidFilterChange = (event) => {
        const filterValue = event.target.value;
        const isUnpaid=filterValue==="false"
        let tempFilters=[]

        setPaidFilter(filterValue);
        if(isUnpaid)
        {
            setDenialFilter("both")
            setDisregardDialog(true)   
            tempFilters = [...tableFiltersPtr.value.filter];
            tempFilters = tempFilters?.filter(
                (item) => unpaidExcludedFilters.includes(item.field) === false
            );
        }

        if (filterValue !== 'both') {
            const cf = {
                field: 'isPaid',
                equator: 'equals',
                value: filterValue,
            }
            if (customFilter && customFilter.length > 0) {
                const existingFilter = customFilter.filter(x => x.field !== 'isPaid');
                if (isUnpaid) {
                    setMulti({
                        list: [],
                        customFilter: [...existingFilter, cf]?.filter(
                            (item) => unpaidExcludedFilters.includes(item.field) === false
                        ),
                        filter: tempFilters,
                    });
                } else {
                    setMulti({
                        list: [],
                        customFilter: [...existingFilter, cf],
                    });
                }
            } else {
                if (isUnpaid) {
                    setMulti({
                        list: [],
                        customFilter: [cf]?.filter(
                            (item) => unpaidExcludedFilters.includes(item.field) === false
                        ),
                        filter: tempFilters,
                    });
                } else {
                    setMulti({
                        list: [],
                        customFilter: [cf],
                    });
                }
            }

        } else {
            if (customFilter && customFilter.length > 0) {
                const existingFilter = customFilter.filter(x => x.field !== 'isPaid');
                if (existingFilter.length === 0) {
                    setMulti({
                        isCustomFilterSetEmpty: true,
                        list: [],
                        customFilter: existingFilter
                    });
                } else {
                    setMulti({
                        list: [],
                        customFilter: existingFilter
                    });
                }
            }
        }
    };

    const applyContractsStateChange = (
        filterValue,
        excludedStates = undefined,
        includedStates = undefined
    ) => {
        setContractState(filterValue.toLowerCase());

        const filtersContractsBasedOnStates =
            tableFiltersPtr?.value?.filter?.filter((item) => {
                if (item?.field !== "contract.name") return true;
                let existingContractsWithSameState = includedStates
                    ? tinyContracts?.find(
                          (rec) =>
                              rec?.name === item?.value &&
                              rec?.state?.toLowerCase() === includedStates
                      )
                    : tinyContracts?.find(
                          (rec) =>
                              rec?.name === item?.value &&
                              rec?.state?.toLowerCase() !== excludedStates
                      );
                if (existingContractsWithSameState) {
                    return true;
                }
                return false;
            });

        if (filterValue !== "both") {
            const cf = {
                field: "contract.contractState.name",
                equator: "equals",
                value: filterValue,
            };
            if (customFilter && customFilter.length > 0) {
                const existingFilter = customFilter.filter(
                    (x) => x.field !== "contract.contractState.name"
                );
                setMulti({
                    list: [],
                    customFilter: [...existingFilter, cf],
                    ...((excludedStates || includedStates) &&
                    filtersContractsBasedOnStates
                        ? { filter: filtersContractsBasedOnStates }
                        : {}),
                });
            } else {
                setMulti({
                    list: [],
                    customFilter: [cf],
                    ...((excludedStates || includedStates) &&
                    filtersContractsBasedOnStates
                        ? { filter: filtersContractsBasedOnStates }
                        : {}),
                });
            }
        } else {
            if (customFilter && customFilter.length > 0) {
                const existingFilter = customFilter.filter(
                    (x) => x.field !== "contract.contractState.name"
                );
                if (existingFilter.length === 0) {
                    setMulti({
                        isCustomFilterSetEmpty: true,
                        list: [],
                        customFilter: existingFilter,
                    });
                } else {
                    setMulti({
                        list: [],
                        customFilter: existingFilter,
                    });
                }
            }
        }
    };

    const handleStateChange = (event) => {
        const filterValue = event.target.value;

        const doesHaveFiltersWithContractState =
            filterValue === "both"
                ? false
                : contractState === "both"
                ? isContractNameFilterApplied(filterValue)
                : isContractNameFilterApplied();
        if (doesHaveFiltersWithContractState) {
            setContractsStateChangeConfirm({
                open: true,
                callBack: () =>
                    contractState === "both"
                        ? applyContractsStateChange(
                              filterValue,
                              undefined,
                              filterValue
                          )
                        : applyContractsStateChange(filterValue, contractState),
            });
            return;
        }
        applyContractsStateChange(filterValue);
    };

    const setDates = (beginDate, endDate, isDateFilterActive, customField, relativeFilter) => {
        if (isDateFilterActive) {
            const dateFilter = [
                {
                    field: customField,
                    equator: 'greater_than_or_equals_to',
                    value: beginDate,
                    relativeFilter
                },
                {
                    field: customField,
                    equator: 'less_than_or_equals_to',
                    value: endDate,
                    relativeFilter
                }
            ];

            const existingFilters = customFilter.filter((cf) => {
                return !filterFields.find((f) => {
                    return cf.field === f.value;
                });
            });
            setMulti({
                list: [],
                customFilter: [
                    ...existingFilters,
                    ...dateFilter,
                ]
            });
        } else {
            const existingFilters = customFilter.filter((cf) => {
                return !filterFields.find((f) => {
                    return cf.field === f.value;
                });
            });
            if (existingFilters.length === 0) {
                setMulti({
                    isCustomFilterSetEmpty: true,
                    list: [],
                    customFilter: existingFilters
                });
            } else {
                setMulti({
                    list: [],
                    customFilter: existingFilters
                });
            }
        }
    }

    const handleAccordionOpen = () => {
        setAccordionOpen((prevState) => !prevState);
    }

    const handleAccordionClose = () => {
        setAccordionOpen(false);
    }

    const handleCloseDisregardDialog = () => {
        setDisregardDialog(false)   
        
    }
    const switchToServiceDate = () => {
        handleCloseDisregardDialog()
        setDates(
            startEF ? startEF?.value : getStartDate("Last12Months"),
            endEF ? endEF?.value : getEndDate("Last12Months"),
            true,
            "servicedate",
            selectedDate[0].relativeFilter ?? "Last12Months"
        );
    };



    return (
        (<div>
            <Grid container spacing={1} className={classes.gridMDMargin}>
                <Grid item>
                    <DateRangeControl
                        refresh={handleRefresh}
                        filterName="Date Filter"
                        setDates={setDates}
                        fields={isPaidFilter==="false" ? [filterFields[1]]:filterFields}
                        customFilter={customFilter}
                        hasCustomField={true}
                        relativeFilter={relativeFilter}
                        disabled={pending || ignoreDueToQuickSearch}
                        isForClaims={true}
                        relativeFilterValue={relativeFilterValue}
                        setRelativeFilter={setRelativeFilter}
                    />
                </Grid>
                <Grid item>
                    <FormControl className={classes.formControlClaim}>
                        <InputLabel id="demo-simple-select-label">Paid</InputLabel>
                        <Select
                            disabled={pending || ignoreDueToQuickSearch}
                            labelId="Paid-label"
                            id="Paid"
                            label="isPaid"
                            value={isPaidFilter}
                            onChange={handlePaidFilterChange}
                        >
                            <MenuItem value="true">Yes</MenuItem>
                            <MenuItem value="false">No</MenuItem>
                            <MenuItem value="both">Both</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl className={classes.formControlVarianceStatus}>
                        <InputLabel id="demo-simple-select-label">Variance Status</InputLabel>
                        <Select
                            disabled={pending || (!pending && isPaidFilter==="false") || ignoreDueToQuickSearch}
                            labelId="followup-label"
                            id="DenailFilter"
                            label="DenailFilter"
                            value={denialFilter || ignoreDueToQuickSearch}
                            onChange={handleDenialFilterChange}
                        >
                            <MenuItem value="true">Denials</MenuItem>
                            <MenuItem value="false">Underpayments</MenuItem>
                            <MenuItem value="both">Both</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item className={classes.filterIcon}>
                    <Grid container className='align-items-center h-100'>
                        <Tooltip title='View remaining filters'>
                            <IconButton onClick={handleAccordionOpen} size="large">
                                <i className="fas fa-filter font-16"></i>
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>


                <Grid item className={classes.defaultVisibleFilters}>
                    <FormControl className={`${classes.formControlStatus} ${classes.ackStatus}`}>
                        <InputLabel id="demo-simple-select-label">Ack. Status</InputLabel>
                        <Select
                            disabled={pending || ignoreDueToQuickSearch}
                            labelId="Acknowledged-label"
                            id="Acknowledged"
                            label="Acknowledged"
                            value={acknowledgeFilter}
                            onChange={handleAcknowledgedFilterChange}
                        >
                            <MenuItem value="true">Acknowledged</MenuItem>
                            <MenuItem value="false">Unacknowledged</MenuItem>
                            <MenuItem value="both">Both</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item className={classes.defaultVisibleFilters}>
                    <FormControl className={`${classes.formControlStatus} ${classes.width}`}>
                        <InputLabel id="demo-simple-select-label">Follow Up</InputLabel>
                        <Select
                            disabled={pending || ignoreDueToQuickSearch}
                            labelId="followup-label"
                            id="FollowUp"
                            label="FollowUp"
                            value={followUpFilter}
                            onChange={handleFollowupFilterChange}
                        >
                            <MenuItem value="true">Yes</MenuItem>
                            <MenuItem value="false">No</MenuItem>
                            <MenuItem value="both">Both</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item className={classes.defaultVisibleFilters}>
                    <FormControl className={classes.formControlState}>
                        <InputLabel id="ContractState">Contract State</InputLabel>
                        <Select
                            disabled={pending || ignoreDueToQuickSearch}
                            labelId="ContractState"
                            id="ContractState"
                            label="Contract State"
                            value={contractState}
                            onChange={handleStateChange}
                        >
                            <MenuItem value="both">All</MenuItem>
                            <MenuItem value='draft'>Draft</MenuItem>
                            <MenuItem value='finalized'>Finalized</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item>
                    <TextField
                        label="Claim Search"
                        onKeyUp={(event)=> {
                            if (event.key === "Enter" && claimNumber.length > 2) {
                                const trimmedClaimNumber=claimNumber.trim();
                                setMulti({
                                    searchTerm: trimmedClaimNumber,
                                });
                            }
                        }}
                        disabled={pending }
                        id="standard-start-adornment"
                        className={classes.claimSearchField}
                        value={claimNumber}
                        onChange={handleClaimNumberSearchChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        sx={{ m: 1, width: "110px" }}
                        placeholder='Name/#'
                        InputProps={{
                            endAdornment: (
                                <>
                                    {claimNumber.length > 0 && (
                                        <CloseIcon
                                            onClick={() =>
                                                handleClaimNumberSearchChange({
                                                        target: { value: "" },
                                                    }
                                                )
                                            }
                                            sx={{
                                                mr: "5px",
                                                fontSize: "15px",
                                                cursor: "pointer",
                                            }}
                                        />
                                    )}
                                    <SearchIcon
                                        sx={{ fontSize: "14px", opacity: 0.7 }}
                                    />
                                </>
                            ),
                        }}
                        variant="standard"
                        helperText="Minimum 3 Characters"
                    />
                </Grid>
                <Grid item className={classes.defaultVisibleFilters}    >
                    <FormControlLabel
                        disabled={pending || isSignificanceDisabled || (!pending && isPaidFilter==="false") || ignoreDueToQuickSearch}
                        className={classes.switch}
                        control={
                            <Switch
                                checked={significance}
                                size="small"
                                color="primary"
                                onChange={handleSignificanceChange}
                            />
                        }
                        label="Significant Variance?"
                        labelPlacement="start"
                    />
                </Grid>

                <Grid item className={classes.defaultVisibleFilters}    >
                    <FormControlLabel
                    disabled={pending || isAssignedFilterApplied()}
                        // disabled={pending}
                        className={classes.switch}
                        control={
                            <Switch
                                checked={assignedToMe}
                                size="small"
                                color="primary"
                                onChange={handleAssignedToMeChange}
                            />
                        }
                        label="Assigned to me"
                        labelPlacement="start"
                    />
                </Grid>

                <Grid className={`${classes.claimFilterAccordion} ${!isAccordionOpen && 'd-none'}`}>
                    <Grid container className={`justify-content-between align-items-center p-3 ${classes.filterBorderBottom}`}>
                        <h5 className='m-0'>Filter</h5>
                        <IconButton onClick={handleAccordionClose} className='p-2' size="large">
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6}>
                            <FormControl className={classes.accordionFormControl}>
                                <InputLabel id="demo-simple-select-label">Ack. Status</InputLabel>
                                <Select
                                    disabled={pending || ignoreDueToQuickSearch}
                                    labelId="Acknowledged-label"
                                    id="Acknowledged"
                                    label="Acknowledged"
                                    value={acknowledgeFilter}
                                    onChange={handleAcknowledgedFilterChange}
                                >
                                    <MenuItem value="true">Acknowledged</MenuItem>
                                    <MenuItem value="false">Unacknowledged</MenuItem>
                                    <MenuItem value="both">Both</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl className={classes.accordionFormControl} > 
                                <InputLabel id="demo-simple-select-label">Follow Up</InputLabel>
                                <Select
                                    disabled={pending || ignoreDueToQuickSearch}
                                    labelId="followup-label"
                                    id="FollowUp"
                                    label="FollowUp"
                                    value={followUpFilter}
                                    onChange={handleFollowupFilterChange}
                                >
                                    <MenuItem value="true">Yes</MenuItem>
                                    <MenuItem value="false">No</MenuItem>
                                    <MenuItem value="both">Both</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl className={classes.accordionFormControl}>
                                <InputLabel id="ContractState">Contract State</InputLabel>
                                <Select
                                    disabled={pending || ignoreDueToQuickSearch}
                                    labelId="ContractState"
                                    id="ContractState"
                                    label="Contract State"
                                    value={contractState}
                                    onChange={handleStateChange}
                                >
                                    <MenuItem value="both">All</MenuItem>
                                    <MenuItem value='draft'>Draft</MenuItem>
                                    <MenuItem value='finalized'>Finalized</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControlLabel
                                disabled={pending || isSignificanceDisabled || (!pending && isPaidFilter==="false") || ignoreDueToQuickSearch}
                                className={classes.switch}
                                control={
                                    <Switch
                                        checked={significance}
                                        size="small"
                                        color="primary"
                                        onChange={handleSignificanceChange}
                                    />
                                }
                                label="Significant Variance?"
                                labelPlacement="start"
                            />
                        </Grid>


                        
                    </Grid>
                </Grid>
            </Grid>
            <PrimaryFiltersDisregardDialog open={disregardDialog} handleClose={handleCloseDisregardDialog} ef={
               selectedDate
            } switchDate={switchToServiceDate}/>



            <ExcludingContractsConfirmation
                            DELETE_TEXT={`Changing the Contract state will remove any contracts not matching your current state.`}
                            defaultSelected={[]}
                            isConfirmationOnly={true}
                            customConfirmBtnText={"Continue"}
                            customTitle={"Are you sure ?"}
                            handleDelete={() => {
                                contractsStateChangeConfirm?.callBack()
                                setContractsStateChangeConfirm({ open: false })}}
                            defaultDeleteState={contractsStateChangeConfirm}
                            handleClose={() => {
                                setContractsStateChangeConfirm({ open: false });
            
                            }}
                        />
        </div>)
    );
}

const NumberChip = styled('div')({
    backgroundColor: '#f5f5f5',
    padding: '0px 8px',
    borderRadius: '16px',
    fontSize: '12px !important',
    color: '#000',
    marginLeft: '5px'
})

export default ClaimAnalysisTopFilters;
